<template>
  <div class="bdg-select-tabs flex">
    <select-tab
      class="w-1/3 uppercase"
      :class="{ selected: selectedOption === option }"
      :label-text="option.label"
      @click.native="selectOption(option)"
      :key="`st_${i}`"
      v-for="(option, i) in computedOptions"
    />
  </div>
</template>

<script>
import SelectTab from "./SelectTab";
import UsesOptions from "../../elements/UsesOptions";

export default {
  name: "BdgSelectTabs",
  extends: UsesOptions,
  components: { SelectTab }
};
</script>

<style lang="scss" scoped>
.bdg-select-tabs {
  margin: 5px 0;
  .select-tab {
    min-width: auto;
  }
}
</style>
